/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const primaryTargetDtoSchema = z.object({
  title: z.optional(z.string()),
  sub: z.optional(z.string()),
  share: z.optional(z.string()),
});
